module.exports = "<div class=\"content\">\n  <div class=\"container-fluid\">\n    <div class=\"row\">\n      <p>\n        waz view works!\n      </p>\n    </div>\n  </div>\n</div>"


//////////////////
// WEBPACK FOOTER
// /Users/vishitamandloi/Documents/vishitaProjects/waz/angular/adminportal/waz-admin-panel/src/app/dashboard/map/map.component.html
// module id = ../../../../../src/app/dashboard/map/map.component.html
// module chunks = main